'use client';

import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { CheckboxToggle } from '../../../../../common/components/CheckboxToggle/CheckboxToggle';
import { useAutomaticWithdrawals } from '../../AutomaticWithdrawalsContext';

const containerStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'medium',
  padding: 'small',
  bg: 'neutrals.fill_quinary',
  borderRadius: '8px',
  marginTop: 'medium',
});

const textContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'extra_small_2',
  flex: 1,
});

const titleStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'label.medium_bold',
  fontWeight: 'label.medium_bold',
  lineHeight: 'label.medium_bold',
  letterSpacing: 'label.medium_bold',
});

const descriptionStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
  letterSpacing: 'caption.medium_medium',
});

export const AutomaticWithdrawalsToggle: FC = () => {
  const { t } = useClientTranslation();

  const context = useAutomaticWithdrawals();

  return (
    <div className={containerStyles}>
      <div className={textContainerStyles}>
        <p className={titleStyles}>{t('automatic_withdrawals_title')}</p>

        <p className={descriptionStyles}>
          {t('automatic_withdrawals_description_@tenant')}
        </p>
      </div>

      <CheckboxToggle
        checked={context.isEnabled}
        variant="positive"
        onChange={(e) => context.setIsEnabled(e.target.checked)}
      />
    </div>
  );
};
